/** 柜柜的翻译 */
import { getGuiguiTranslate } from '@/apis/common/translate'
import { message } from 'ant-design-vue'
import axios from 'axios'

/** @description 柜柜的翻译数据 */
let guiguiEnJson: Record<string, string> = {}
let isLoading = false

/** @description 获取柜柜的自定义翻译 */
export async function initGuiguiTranslate() {
  try {
    if (isLoading) return
    const { data, status, msg } = await getGuiguiTranslate()
    if (status !== 1) return message.error(msg || '翻译错误')
    const langArr = data?.data?.[0]?.language
    const enJsonUrl = langArr?.find((v: any) => v.code === 'en')?.url
    if (!enJsonUrl) return
    const result = await axios.get(enJsonUrl, {
      responseType: 'json',
    })
    guiguiEnJson = result.data
    isLoading = true
  } catch (error) {
    console.log(error)
  }
}

export { guiguiEnJson }
